import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import { Carousel, Arrows, Track, Slide } from '@fiverr-private/carousel';
import { getContext } from '@fiverr-private/fiverr_context';
import { TYPES, reportSnippetViewMixpanel } from '../../utils/reports/snippet';
import { onSnippetClickEvent } from '../../store/actions';
import { isTranslationPresent } from '../../utils/translation';
import withImpressions from '../shared/hoc/withImpressions';
import { DEFAULT_LOCALE, TEXT } from '../../constants';
import useObserver from '../shared/hooks/useObserver';
import { getPackageEntryClassNames } from '../../utils';
import ReviewItem from './ReviewItem';

const SLIDER_BREAKPOINTS = { default: 1 };

const IMPRESSION_COMPONENT_CLASS = 'reviews-carousel';

const impressionConfig = {
    DOMSelector: `.${IMPRESSION_COMPONENT_CLASS}`,
    getImpressionData: () => ({
        type: 'reviews_snippet_is_shown',
        page: {
            element: {
                name: 'reviews snippet',
                type: TEXT,
            },
            component: {
                name: 'gig_review',
            },
        },
    }),
};

const ReviewsCarousel = ({ reviews, maxLines, onArrowClick = noop }) => {
    const carouselRef = useRef(null);
    const { locale = DEFAULT_LOCALE } = getContext();
    const withTranslation = isTranslationPresent(reviews, locale);
    const packageClass = getPackageEntryClassNames(IMPRESSION_COMPONENT_CLASS);
    const [resetDescription, setResetDescription] = useState(false);

    const handleScroll = () => {
        setResetDescription(true);
        setTimeout(() => setResetDescription(false), 0);
    };

    useObserver({
        observableRef: carouselRef,
        onObserve: () => reportSnippetViewMixpanel({ Size: reviews.length }),
    });

    const renderReviewItem = (props) => (
        <ReviewItem
            {...props}
            withExtendedDescription
            resetDescription={resetDescription}
            maxLines={maxLines}
            withTranslation={withTranslation}
        />
    );

    return (
        <div className={packageClass} ref={carouselRef}>
            <Carousel isInfinite breakpoints={SLIDER_BREAKPOINTS} onScroll={handleScroll} scrollType="single">
                <Arrows onArrowClick={onArrowClick} position="topRight" />
                <Track>
                    {reviews.map((review, index) => (
                        <Slide key={index}>{renderReviewItem(review)}</Slide>
                    ))}
                </Track>
            </Carousel>
        </div>
    );
};

ReviewsCarousel.defaultProps = {
    maxLines: 2,
};

ReviewsCarousel.propTypes = {
    reviews: PropTypes.arrayOf(PropTypes.object).isRequired,
    onArrowClick: PropTypes.func,
    maxLines: PropTypes.number,
};

const SNIPPET_EVENT_TYPE = {
    next: TYPES.snippetNextClicked,
    prev: TYPES.snippetPrevClicked,
};

const mapStateToProps = ({ reviews = [] }) => ({
    reviews,
    onArrowClick: ({ direction, currentSlide }) => {
        onSnippetClickEvent({
            review: reviews[currentSlide],
            type: SNIPPET_EVENT_TYPE[direction],
        });
    },
});

export default connect(mapStateToProps)(withImpressions(ReviewsCarousel, impressionConfig));
